import { Icon } from "@iconify/react";
import { Avatar, Tooltip } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { communityRectangleImage } from "src/assets";
import CustomPopover from "src/components/GeneralComponents/CustomPopover";
import { s3baseUrl } from "src/config/config";
import {
  get_date_with_user_time_zone,
  get_short_string,
  is_small_screen,
  LONG_TEXT_LIMIT,
  string_avatar,
} from "src/utils/constants";
import { htmlDecode, urlify } from "src/utils/convertHtml";
import SingleChildLiveEvent from "./SingleChildLiveEvent";
import { useChat } from "src/Hooks/ChatContext/ChatContext";
import { communityHandScreenshot, communityHeart } from "src/assets";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { addPersonalNoteFromChat } from "src/DAL/member/Member";
import { useLocation } from "react-router-dom";

function SingleCommentLiveEvent(props) {
  const {
    comment,
    handleCommentEdit,
    handleCommentDelete,
    handleCommentPin,
    handleOpenReplyBox,
    handleLikeComment,
    eventDetail,
    handleOpenLikes,
    is_pinned,
    handleOpenPersonalNote,
  } = props;
  const { handleAddChat } = useChat();
  const settings = useContentSetting();
  const { isAccess } = useContentSetting();
  const [isShowCommentMore, setIsShowCommentMore] = useState(true);
  const isPortalsRoute = useLocation().pathname.includes("/live-events");
  const isMyPortalsRoute = useLocation().pathname.includes("/my-events");
  const handleSendMessage = async (row) => {
    handleAddChat(row.member._id);
  };

  const MENU_OPTIONS = [];

  if (comment?.comment_is_self === true || settings.userInfo.is_executive) {
    MENU_OPTIONS.push(
      {
        label: "Edit",
        icon: "akar-icons:edit",
        handleClick: handleCommentEdit,
      },
      {
        label: "Delete",
        icon: "ant-design:delete-twotone",
        handleClick: handleCommentDelete,
      }
    );
  }

  if (settings.userInfo.is_executive) {
    MENU_OPTIONS.push({
      label: comment.is_featured ? "Unpin" : "Pin",
      icon: "akar-icons:pin",
      handleClick: handleCommentPin,
    });
  }

  if (
    (settings.userInfo.is_super_executive || settings.userInfo.is_executive) &&
    isAccess.is_chat_allowed &&
    comment.member._id !== settings.userInfo._id
  ) {
    MENU_OPTIONS.push({
      label: "Message",
      icon: "material-symbols:send",
      handleClick: handleSendMessage,
    });
  }
  if (comment?.action_by === "member" && (isPortalsRoute || isMyPortalsRoute)) {
    MENU_OPTIONS.push({
      label: "Add as  Note",
      icon: "akar-icons:edit",
      handleClick: handleOpenPersonalNote,
    });
  }

  const get_short_date = () => {
    let from_now = moment(
      get_date_with_user_time_zone(
        comment?.createdAt,
        "DD MMM YYYY hh:mm A",
        settings.userInfo.time_zone,
        settings.adminTimeZone
      )
    );

    // from_now = from_now.replace("a few seconds ago", "just now");
    // from_now = from_now.replace("seconds", "s");
    // from_now = from_now.replace("minutes", "m");
    // from_now = from_now.replace("hours", "h");
    // from_now = from_now.replace("day", "d");
    // console.log(from_now._i, "from_nowfrom_nowfrom_nowfrom_now");
    return from_now?._i;
  };

  return (
    <div>
      <div className={"profile-comments inception p-2 mb-1 pb-1"}>
        <div className="d-flex position-relative">
          <div className="poster-name-image d-flex w-100">
            <Avatar
              src={s3baseUrl + comment?.user_info_action_for?.profile_image}
              alt="photoURL"
              style={{ width: 30, height: 30 }}
            >
              {string_avatar(comment?.user_info_action_for?.name)}
            </Avatar>
            <div className="w-100">
              <div className="text-start set-title-width poster-name ps-1 w-100">
                <span className="card-title mb-0 fs-12 fw-500">
                  {htmlDecode(comment?.user_info_action_for?.name)}
                </span>

                {comment.is_featured && (
                  <Icon
                    icon="bi:pin-angle-fill"
                    className="pinned-icon ms-2"
                  ></Icon>
                )}
                {!is_small_screen() && (
                  <span className="date-color float-end pe-4 fw-400 fs-8">
                    {get_short_date()}
                  </span>
                )}
              </div>
              {is_small_screen() && (
                <span className="date-color ps-2">
                  {get_date_with_user_time_zone(
                    comment?.createdAt,
                    "DD MMM YYYY [at] hh:mm A",
                    settings.userInfo.time_zone,
                    settings.adminTimeZone
                  )}
                </span>
              )}
              <div className="post-description ps-1 pt-0 fs-12 fw-400 live-event-comment-message w-100">
                {comment?.message?.length > 200 ? (
                  isShowCommentMore ? (
                    <>
                      <p className="text-start mb-0 pb-1">
                        {" "}
                        {get_short_string(
                          `${htmlDecode(comment?.message)}`,
                          LONG_TEXT_LIMIT
                        )}
                      </p>
                      <span
                        className="ms-2 see-more"
                        onClick={() => {
                          setIsShowCommentMore(false);
                        }}
                      >
                        See More
                      </span>
                    </>
                  ) : (
                    <>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: urlify(htmlDecode(comment?.message)),
                        }}
                        className="text-start mb-0"
                      ></p>
                      <span
                        className="ms-2 see-more"
                        onClick={() => {
                          setIsShowCommentMore(true);
                        }}
                      >
                        See Less
                      </span>
                    </>
                  )
                ) : (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: urlify(htmlDecode(comment?.message)),
                    }}
                    className="text-start date-color mb-0"
                  ></span>
                )}
                {comment.like_count > 0 && (
                  <Tooltip title={`${comment.like_count} Likes`}>
                    <div
                      className="d-flex comment-like-heart mt-2"
                      onClick={() => {
                        handleOpenLikes(comment);
                      }}
                    >
                      <div className="comment-like-heart-image">
                        <img src={communityHeart} alt="" />
                      </div>
                      {comment.like_count > 0 && (
                        <div className="comment-like-heart-count">
                          {comment.like_count}
                        </div>
                      )}
                    </div>
                  </Tooltip>
                )}
              </div>
              <div className="col-12">
                {comment.file_url && (
                  <a
                    href={s3baseUrl + comment.file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="comment-view-attachment"
                  >
                    <span className="chat-image-preview mt-2">
                      <img src={s3baseUrl + comment.file_url} />
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>

          <div className="affirmation-dots">
            <CustomPopover menu={MENU_OPTIONS} data={comment} />
          </div>
        </div>
        {/* <div className="chat-comment-border">
          <hr />
        </div> */}
        <div className="like-reply-inception-box pt-2 py-1 px-2">
          {!is_pinned && (
            <div
              className="comment-reply action-box"
              onClick={() => {
                handleOpenReplyBox(comment);
              }}
            >
              <ChatBubbleOutlineIcon /> Reply
            </div>
          )}
          <div
            className="comment-like action-box"
            onClick={() => {
              handleLikeComment(comment);
            }}
          >
            {comment.is_liked ? (
              <>
                <img src={communityHeart} alt="" /> Liked
              </>
            ) : (
              <>
                <FavoriteBorderIcon /> Like
              </>
            )}
          </div>
        </div>
      </div>

      {comment?.replies?.length > 0 &&
        comment?.replies.map((reply, index) => {
          return (
            <div className="ps-3" key={index}>
              <SingleChildLiveEvent
                reply={reply}
                handleCommentEdit={handleCommentEdit}
                handleCommentDelete={handleCommentDelete}
                handleLikeComment={handleLikeComment}
                comment={comment}
                handleOpenLikes={handleOpenLikes}
                handleOpenPersonalNote={handleOpenPersonalNote}
                isPortalsRoute={isPortalsRoute}
                isMyPortalsRoute={isMyPortalsRoute}
              />
            </div>
          );
        })}
    </div>
  );
}

export default SingleCommentLiveEvent;
